<script>
	import { projectSettings } from "../../config";
	import model from "../../stores/modelStore";
	import { isValid } from "../../validation";

	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import IFrame from "../../components/IFrame.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";

	// props
	export let pageTitle = null;
	export let disabled = false;
	export let persistUrl = false;
	export let lastVisitedPage = null;

	let buttons = null;

	// component state updating
	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;
	}

	const handleSubmit = async (e) => {
		buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError);
			} else {
				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};
</script>

<PageSection>
	<Form {disabled} id="form-agreements" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Funding Agreement and Cost Agreement</h1>
			</FormColumn>
		</FormRow>

		<!--<hr class="primary" />-->

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					If you would like to obtain funding for Shine Lawyers to conduct your claim, provide you with
					updates and assist with any work required to verify and quantify your claim, you may electronically
					execute the Funding Agreement and Costs Agreement by selecting "Confirm Funding Agreement and Cost
					Agreement" below. You do not need to sign these documents to complete your registration.
				</p>
			</FormColumn>
		</FormRow>

		<IFrame title="Agreement" url={projectSettings.agreementUrl}></IFrame>

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					If you are having trouble viewing the agreements or would like to download a copy please click
					<a
						href={projectSettings.agreementUrl}
						title="Funding Agreement and Cost Agreement"
						target="_blank"
						rel="noreferrer">here</a
					>?.
				</p>

				<p>
					<b>Agreement Declaration</b>
				</p>

				<p>By selecting "Confirm Funding Agreement and Cost Agreement" below you confirm that:</p>

				<ul>
					<li>
						I confirm that I am the claimant described above, or am duly authorised to act on the claimant's
						behalf I understand that I am entering into a legally binding agreement (the Funding Agreement
						and Costs Agreement)
					</li>
					<li>
						I confirm that I have been informed of my right to obtain, and have obtained, all independent
						legal, financial and other professional advice before entering into the Agreements that I
						consider necessary
					</li>
					<li>
						I understand that the Australian Securities and Investments Commission's Regulatory Guide ("ASIC
						Regulatory Guide 248") states that the nature of the arrangements between the parties involved
						in a litigation funding arrangement has the potential to result in conflicts between the
						interests of the funder, lawyers and the claimants
					</li>
					<li>
						I expressly consent to this method of acceptance in accordance with <span class="highlight"
							>s9(1) of the Electronic Transactions (New South Wales) Act 2000 (AMEND ACCORDINGLY)</span
						> and accept the terms of the agreement by electronic acceptance
					</li>
					<li>
						I consent to Shine Lawyers and <span class="highlight"
							>Augusta Pool 1 UK Limited (AMEND ACCORDINGLY)</span
						>
						collecting, storing, using and disclosing personal information provided by me in accordance with
						and subject to the Agreements and the Privacy Policy which is available on the Shine website.
					</li>
					<li>
						I understand that I have a cooling off period of <span class="highlight"
							>14 days (AMEND ACCORDINGLY)</span
						>
						from the date I sign this registration form, which cooling off period enables me to seek external
						legal advice, raise any questions, negotiate terms or withdraw from the agreements
					</li>
				</ul>
			</FormColumn>
		</FormRow>

		<FormRow>
			<FormColumn cols="12">
				<Checkbox
					required="true"
					bind:checked={$model.agreementConfirmed}
					label="Confirm Funding Agreement and Cost Agreement"
					id="agreementConfirmed"
				></Checkbox>
			</FormColumn>
		</FormRow>

		<FormRow class="confirmation-hide">
			<FormColumn>
				<NavigationButtons bind:buttons nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	.highlight {
		color: red;
	}
</style>
